

































































import { Vue, Component } from 'vue-property-decorator';

import * as api from '@/api';
import DayTimeSlot from '../day-time-slot.vue';

const TODAY: number = new Date(new Date().setHours(0, 0, 0, 0)).valueOf();

@Component({
    components: {
        DayTimeSlot
    }
})
export default class extends Vue {
    currentYear: string = '';
    showModal: boolean = false;
    adjustedWorkingDayForm: any[] = [];
    activeItem: any = {
        name: '',
        date: '',
        dateList: [],
        time: '',
        timeList: []
    };

    yearOptions: any = {
        disabledDate(date) {
            const currentDate = new Date(TODAY);
            const yearGap = currentDate.getFullYear() - date.getFullYear();
            return yearGap > 2 || yearGap < -1;
        }
    };

    dateOptions: any = {
        disabledDate(date: any) {
            const currentDate = new Date(TODAY);
            return date.getTime() < TODAY || date.getFullYear() > currentDate.getFullYear();
        }
    };

    created() {
        this.currentYear = new Date(TODAY).getFullYear().toString();
    }

    mounted() {
        this.getAdjustedWorkingDaySetting();
    }

    workTimeChange(val) {
        this.activeItem.timeList = val;
    }

    async submitEdit() {
        if (!this.activeItem.timeList.length) {
            this.$mtd.message.error('工作时间必填！');
            return;
        }
        this.submitAdjustedWorkingDay();
    }

    async submitAdjustedWorkingDay() {
        const res = await api.ticketApi.updateRgAdjustedWorkDaySetting({
            rgId: this.rgId,
            year: Number(this.currentYear),
            holidayBO: {
                name: this.activeItem.name,
                workTime: this.activeItem.timeList,
                dateList: this.activeItem.dateList,
                holidayTypeEnum: 'ADJUSTED_WORKING'
            }
        });
        if (res.code === 200) {
            this.showModal = false;
            this.$mtd.message.success('编辑成功');
            this.getAdjustedWorkingDaySetting();
        }
    }

    handleEdit(row) {
        this.showModal = true;
        this.activeItem = { ...row };
    }

    cancelEdit() {
        this.showModal = false;
        this.getAdjustedWorkingDaySetting();
    }

    async getAdjustedWorkingDaySetting() {
        const res = await api.ticketApi.getRgAdjustedWorkDaySetting({ rgId: this.rgId, year: Number(this.currentYear) });
        if (res.code === 200) {
            this.adjustedWorkingDayForm = this.handleAdjustedWorkingDaySetting(res.data);
        }
    }

    // !参考 holiday-time-content.vue 中的 handleHolidayList.
    handleAdjustedWorkingDaySetting(setting: api.ticketApi.IGetRgAdjustedWorkDaySettingResponse) {
        const list = [];
        const holidayList = Object.values(setting || {}).sort((a, b) => a.dateList[0] - b.dateList[0]);
        holidayList.forEach(holiday => {
            const dayMap = Object.values(holiday.singleDayHolidayMap || {}).sort((a, b) => a.dateList[0] - b.dateList[0]);
            const amount = dayMap.length;
            dayMap.forEach((item: any, index) => {
                list.push({
                    name: item.name,
                    date: item.displayDate,
                    time: item.displayWorkTime && item.displayWorkTime.join(','),
                    dateList: item.dateList,
                    timeList: item.workTime,
                    isOfficial: item.holidayTypeEnum === 'OFFICIAL',
                    id: item.id || 0,
                    amount,
                    index
                });
            });
        });
        return list;
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
